<template>
    <div :class="{'page-wrapper': true, 'toggled': isSidebarToggled}"
         v-on:selectstart.prevent
         v-on:contextmenu.prevent="preventRightClick"
         v-on:copy.prevent="preventCopy"
         v-on:cut.prevent="preventCopy"
         v-on:paste.prevent="preventCopy">
        <!-- sidebar-wrapper -->
        <nav id="sidebar" class="sidebar-wrapper sidebar-dark">
            <div class="sidebar-content" data-simplebar style="height: calc(100% - 60px);">
                <div class="sidebar-brand">
                    <a href="/">
                        <img :src="main?.settings?.logo" height="24" class="logo-light-mode" alt="">
                        <img :src="main?.settings?.logo" height="24" class="logo-dark-mode" alt="">
                        <span class="sidebar-colored">
                                    <img :src="main?.settings?.logo" height="24" alt="">
                            </span>
                    </a>
                </div>
                <h5 class="m-0 ms-4 text-muted mt-3">
                    {{ subscribe?.course?.name }}
                </h5>
                <ul class="sidebar-menu">
                    <!--                        <li class="sidebar-dropdown">-->
                    <!--                            <a ><i class="ti ti-home me-2"></i>Dashboard</a>-->
                    <!--                            <div class="sidebar-submenu">-->
                    <!--                                <ul>-->
                    <!--                                    <li><a href="index.html">Analytics</a></li>-->
                    <!--                                    <li><a href="index-crypto.html">Cryptocurrency</a></li>-->
                    <!--                                </ul>-->
                    <!--                            </div>-->
                    <!--                        </li>-->
                    <li class="">
                        <router-link :to="{name: 'dashboard.home', }"
                        ><i class="ti ti-home me-2"></i>
                            Home
                        </router-link>
                    </li>
                    <p class="m-0 ms-4 text-muted mt-3">
                        QUESTIONS
                    </p>
                    <li class="">
                        <router-link
                            :to="{name: 'questions.courses.filter', params: { 'subscribe_id': $route?.params?.subscribe_id }}"
                        ><i class="ti ti-folder me-2"></i>
                            Question bank
                        </router-link>
                    </li>
                    <!--                    <li>-->
                    <!--                        <router-link :to="{name: 'questions.courses.filter', params: { 'subscribe_id': $route?.params?.subscribe_id }}"-->
                    <!--                                     ><i class="ti ti-alarm-clock me-2"></i>-->
                    <!--                            Timed tests-->
                    <!--                        </router-link>-->
                    <!--                    </li>-->
                    <li>
                        <router-link
                            :to="{name: 'mock_exams.index', params: { 'subscribe_id': $route?.params?.subscribe_id }}"
                        ><i class="ti ti-crown me-2"></i>
                            Mock exams
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            :to="{name: 'student_answers.index', params: { 'subscribe_id': $route?.params?.subscribe_id }}"
                        ><i class="ti ti-check-box me-2"></i>
                            Review questions
                            <!--                            and key concepts-->
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            :to="{name: 'notes.index', params: { 'subscribe_id': $route?.params?.subscribe_id }}"
                        ><i class="ti ti-notepad me-2"></i>
                            Notes
                        </router-link>
                    </li>

                    <li class="sidebar-dropdown">

                        <a data-bs-toggle="collapse" href="#multiCollapseExample1" role="button" aria-expanded="false" aria-controls="multiCollapseExample1">
                            <i class="ti ti-stats-up me-2"></i> Performance
                        </a>
                        <div class="collapse multi-collapse sidebar-submenu d-block" id="multiCollapseExample1">
                            <ul>
                                <li>
                                    <router-link
                                        :to="{name: 'performance.summary', params: { 'subscribe_id': $route?.params?.subscribe_id }}">
                                        Summary
                                    </router-link>
                                </li>
                                <li>
                                    <router-link
                                        :to="{name: 'performance.categories', params: { 'subscribe_id': $route?.params?.subscribe_id }}">
                                        Categories
                                    </router-link>
                                </li>
<!--                                <li><a href="#">Analytics</a></li>-->
<!--                                <li><a href="#">By category</a></li>-->
<!--                                <li><a href="#">Over time</a></li>-->
                            </ul>
                        </div>
                    </li>

                    <li>
                        <router-link
                            :to="{name: 'question_discussions.index', params: { 'subscribe_id': $route?.params?.subscribe_id }}"
                        ><i class="ti ti-comments me-2"></i>
                            Comment threads
                        </router-link>
                    </li>
<!--                    <li>-->
<!--                        <router-link-->
<!--                            :to="{name: 'book_specialties.index', params: { 'subscribe_id': $route?.params?.subscribe_id }}"-->
<!--                        ><i class="ti ti-book me-2"></i>-->
<!--                            Open textbook-->
<!--                        </router-link>-->
<!--                    </li>-->
                    <li>
                        <router-link
                            :to="{name: 'books.index', params: { 'subscribe_id': $route?.params?.subscribe_id }}"
                        ><i class="ti ti-book me-2"></i>
                            Open textbook
                        </router-link>
                    </li>
                    <li>
                        <a href="javascript:void(0)" @click="resetCourse"><i class="ti ti-reload me-2"></i>
                            reset course
                        </a>
                    </li>
                    <!--                    <p class="m-0 ms-4 text-muted mt-3">-->
                    <!--                        CUSTOM REVISION SETS-->
                    <!--                    </p>-->
                    <!--                    <li>-->
                    <!--                        <router-link :to="{name: 'questions.courses.filter', params: { 'subscribe_id': $route?.params?.subscribe_id }}"-->
                    <!--                                     ><i class="ti ti-bag me-2"></i>-->
                    <!--                            Revision sets-->
                    <!--                        </router-link>-->
                    <!--                    </li>-->
                    <!--                    <p class="m-0 ms-4 text-muted mt-3">-->
                    <!--                        TEXTBOOK-->
                    <!--                    </p>-->
                    <!--                    <li>-->
                    <!--                        <router-link :to="{name: 'questions.courses.filter', params: { 'subscribe_id': $route?.params?.subscribe_id }}"-->
                    <!--                                     ><i class="ti ti-book me-2"></i>-->
                    <!--                            Open textbook-->
                    <!--                        </router-link>-->
                    <!--                    </li>-->
                </ul>
                <!-- sidebar-menu  -->
            </div>
            <!-- Sidebar Footer -->
            <!--            <ul class="sidebar-footer list-unstyled mb-0">-->
            <!--                <li class="list-inline-item mb-0">-->
            <!--                    <a href="https://1.envato.market/landrick" target="_blank" class="btn btn-icon btn-soft-light"><i-->
            <!--                        class="ti ti-shopping-cart"></i></a> <small class="text-muted fw-medium ms-1">Buy Now</small>-->
            <!--                </li>-->
            <!--            </ul>-->
            <!-- Sidebar Footer -->
        </nav>
        <!-- sidebar-wrapper  -->

        <!-- Start Page Content -->
        <main class="page-content bg-light">
            <!-- Top Header -->
            <div class="top-header">
                <div class="header-bar d-flex justify-content-between">
                    <div class="d-flex align-items-center">
                        <a href="#" class="logo-icon me-3">
                            <img src="/assets/images/logo-icon.png" height="30" class="small" alt="">
                            <span class="big">
                                        <img src="/assets/images/logo-dark.png" height="24" class="logo-light-mode"
                                             alt="">
                                        <img src="/assets/images/logo-light.png" height="24" class="logo-dark-mode"
                                             alt="">
                                    </span>
                        </a>
                        <a id="close-sidebar" class="btn btn-icon btn-soft-light" @click="toggleSidebar">
                            <i class="ti ti-menu"></i>
                        </a>
                        <!--                            <div class="search-bar p-0 d-none d-md-block ms-2">-->
                        <!--                                <div id="search" class="menu-search mb-0">-->
                        <!--                                    <form role="search" method="get" id="searchform" class="searchform">-->
                        <!--                                        <div>-->
                        <!--                                            <input type="text" class="form-control border rounded" name="s" id="s" placeholder="Search Keywords...">-->
                        <!--                                            <input type="submit" id="searchsubmit" value="Search">-->
                        <!--                                        </div>-->
                        <!--                                    </form>-->
                        <!--                                </div>-->
                        <!--                            </div>-->
                    </div>

                    <ul class="list-unstyled mb-0">

                        <li class="list-inline-item mb-0">
                                <span class="px-3">
                                    {{ auth.user('name') }}
                                </span>
                        </li>

                        <li class="list-inline-item mb-0 ms-1">
                            <div class="dropdown dropdown-primary">
                                <button type="button" class="btn btn-soft-light dropdown-toggle p-0"
                                        data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <img src="/assets/images/graduating-student.png"
                                         class="avatar avatar-ex-small rounded" alt="">
                                </button>
                                <div class="dropdown-menu dd-menu dropdown-menu-end shadow border-0 mt-3 py-3"
                                     style="min-width: 200px;">
                                    <!--                                        <a class="dropdown-item d-flex align-items-center text-dark pb-3" href="profile.html">-->
                                    <!--                                            <img src="/assets/images/graduating-student.png" class="avatar avatar-md-sm rounded-circle border shadow" alt="">-->
                                    <!--                                            <div class="flex-1 ms-2">-->
                                    <!--                                                <span class="d-block">{{ auth.user('name') }}</span>-->
                                    <!--&lt;!&ndash;                                                <small class="text-muted">UI / UX Designer</small>&ndash;&gt;-->
                                    <!--                                            </div>-->
                                    <!--                                        </a>-->
                                    <!--                                        <a class="dropdown-item text-dark" href="index.html"><span class="mb-0 d-inline-block me-1"><i class="ti ti-home"></i></span> Dashboard</a>-->
                                    <!--                                        <a class="dropdown-item text-dark" href="profile.html"><span class="mb-0 d-inline-block me-1"><i class="ti ti-settings"></i></span> Profile</a>-->
                                    <!--                                        <a class="dropdown-item text-dark" href="email.html"><span class="mb-0 d-inline-block me-1"><i class="ti ti-mail"></i></span> Email</a>-->
                                    <!--                                        <div class="dropdown-divider border-top"></div>-->
                                    <!--                                        <a class="dropdown-item text-dark" href="lock-screen.html"><span class="mb-0 d-inline-block me-1"><i class="ti ti-lock"></i></span> Lockscreen</a>-->
                                    <a class="dropdown-item text-dark" @click="auth.logout()" href="#">
                                        <span class="mb-0 d-inline-block me-1"><i class="ti ti-logout"></i></span>
                                        Logout
                                    </a>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- Top Header -->


            <div class="container-fluid">
                <div class="layout-specing">

                    <slot></slot>

                </div>
            </div><!--end container-->
            <!--                <footer class="shadow py-3">-->
            <!--                    <div class="container-fluid">-->
            <!--                        <div class="row align-items-center">-->
            <!--                            <div class="col">-->
            <!--                                <div class="text-sm-start text-center mx-md-2">-->
            <!--                                    <p class="mb-0 text-muted">-->
            <!--                                        © 2024 {{ main?.settings?.title }}. Design with <i class="mdi mdi-heart text-danger"></i>-->
            <!--&lt;!&ndash;                                        by <a href="https://imockup.net/" target="_blank" class="text-reset">مٌكعبات</a>&ndash;&gt;-->
            <!--                                        .</p>-->
            <!--                                </div>-->
            <!--                            </div>&lt;!&ndash;end col&ndash;&gt;-->
            <!--                        </div>&lt;!&ndash;end row&ndash;&gt;-->
            <!--                    </div>&lt;!&ndash;end container&ndash;&gt;-->
            <!--                </footer>-->
            <!-- End -->
        </main>
        <!--End page-content" -->
    </div>

</template>
<script>
import {useToast} from "vue-toastification";

const toast = useToast();

export default {
    name: "dashboard-layout",
    components: {},
    inject: ['auth'],
    props: ['main'],
    data() {
        return {
            isSidebarToggled: true,
            // subscribe: {},
            menuStates: [false, false]
        }
    },
    async created() {
        // this.getSubscribe();
        this.jsTheme();
    },
    methods: {
        resetCourse() {
            if (confirm('Are you sure you want to reset the course?')) {
                axios.post(`subscriptions/${this.$route.params.subscribe_id}/reset`).then(response => {
                    toast.success('Course reset successfully',{ timeout: 3000, icon: 'fa-solid fa-check' });
                    this.$router.push({name: 'dashboard.home'});
                }, response => {
                    toast.error('Failed to reset course' ,{ timeout: 3000, icon: 'fa-solid fa-times' });
                });
            }
        },
        preventRightClick(event) {
            event.preventDefault();
            // alert("النقر بزر الفأرة الأيمن غير مسموح.");
        },
        preventCopy(event) {
            event.preventDefault();
            alert("عمليات النسخ والقص واللصق غير مسموح بها.");
        },
        toggleSidebar() {
            this.isSidebarToggled = !this.isSidebarToggled;
        },
        jsTheme() {
            setTimeout(function (){
                activateSidebarMenu();
            },100);
        // if(document.getElementById("close-sidebar")){
        //     document.getElementById("close-sidebar").addEventListener("click", function() {
        //         document.getElementsByClassName("page-wrapper")[0].classList.toggle("toggled");
        //     });
        // }
        },
        scrollToTop() {
            window.scrollTo(0, 0);
        },
        toggleMenu(index) {
            // تحديث المصفوفة مباشرة باستخدام spread operator
            this.menuStates = this.menuStates.map((state, i) => i === index ? !state : state);
        },
        getSubscribe() {

            // const id = toast.info('Getting content ...',{ icon: 'fa-solid fa-download' });
            //
            // axios.get(`subscriptions/${this.$route.params.subscribe_id}`, {}).then(response => {
            //
            //     this.subscribe = response.data.data;
            //
            //     toast.dismiss(id);
            // }, response => {
            //     toast.dismiss(id);
            // });
        },

    },
}
</script>
